import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { updateCardInfo } from 'redux/accountInfo/accountInfoSlice'
import { getAuthToken } from 'redux/authToken/async-thunks'
import { updateBusinessInfoState } from 'redux/businessInfo/businessInfoSlice'
import { updateInvoiceState } from 'redux/invoice/invoiceSlice'
import { AppThunkAction } from 'redux/store'
import switchAccountAPI from 'services/switchAccount'
import {
  SwitchAccountInfoRequest,
  SwitchAccountResponse
} from 'services/switchAccount/typings'
import { AccountIndicatorType } from 'typings/registration'
import { ServerError } from 'typings/serverError'
import {
  SwitchAccountInfo,
  SwitchAccountInfoState
} from 'typings/switchAccount'

export const initState: SwitchAccountInfoState = {
  response: {} as SwitchAccountInfo,
  error: null,
  isLoading: true,
  isResponseFail: false
}

const onSuccess =
  (response: SwitchAccountResponse): AppThunkAction =>
  dispatch => {
    const {
      'cipher.accountId': accountID,
      authCode,
      'cipher.partialAccountId': accountNumber,
      relationship
    } = response

    dispatch(
      getAuthToken({
        authCode,
        accountID,
        accountNumber,
        isSwitchAccountFlow: true,
        accountIndicator: relationship.slice(0, 1) as AccountIndicatorType
      })
    )

    dispatch(updateCardInfo({ isDataLoading: true }))
    dispatch(
      updateInvoiceState({
        isDataLoading: true
      })
    )
    dispatch(
      updateBusinessInfoState({
        contactInfo: []
      })
    )
  }

export const getSwitchAccountInfo = createAsyncThunk(
  'switchAccountSlice/getSwitchAccountInfo',
  async (payload: SwitchAccountInfoRequest, { dispatch, rejectWithValue }) => {
    try {
      const response = await switchAccountAPI.switchAccount(payload)
      dispatch(onSuccess(response))
      return response
    } catch (error) {
      return rejectWithValue(error as ServerError)
    }
  }
)

export const switchAccountSlice = createSlice({
  name: 'switchAccountSlice',
  initialState: initState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(
        getSwitchAccountInfo.pending,
        (state: SwitchAccountInfoState) => {
          state.isLoading = true
        }
      )
      .addCase(
        getSwitchAccountInfo.fulfilled,
        (
          state: SwitchAccountInfoState,
          action: PayloadAction<SwitchAccountResponse>
        ) => {
          state.isLoading = false
          state.response = action.payload
        }
      )
      .addCase(
        getSwitchAccountInfo.rejected,
        (state: SwitchAccountInfoState, action: PayloadAction<unknown>) => {
          state.isLoading = false
          state.error = action.payload as ServerError
        }
      )
  }
})

export default switchAccountSlice.reducer
